import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/icons-material/esm/Phone.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material-nextjs/esm/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Container/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/CssBaseline/CssBaseline.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Link/Link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/document-language.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/data-layer/page-info-data-layer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/footer/customer-service.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/footer/deals-signup.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/footer/footer-ui.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/forms/email-signup/email-signup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/header/navbar/desktop-navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/header/navigation/login/login-nav-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/locale-selector/locale-dropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/measurement-protocol/conditional-measurement-protocol.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/promotional-banner/promotional-banner-client-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/search-predictive/search-predictive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/standard-layout/main-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/standard-layout/standard-header/ClientHeaderScrollEffect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/standard-layout/standard-header/mobile/mobile-component-manager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/LegacyThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/market-currency-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/react-query-provider.tsx");
